import { Button, Col, Drawer, Form, Input, Row, Space } from "antd";
import useCategoryApi from "views/Catalog/Categories/hooks/useCategoryApi";
import { ApolloQueryResult, OperationVariables } from "@apollo/client";
import useNotification from "utils/hooks/useNotification";
import { getFormError } from "utils/getFormError";
const { TextArea } = Input;
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useState } from "react";
import React from "react";
import { FaPlus } from "react-icons/fa6";
import TooltipButton from "views/Documents/components/TooltipButton";

interface CreateCategoryDrawerPropsTypes {
  refetchCategories?: (
    variables?: Partial<OperationVariables> | undefined,
  ) => Promise<ApolloQueryResult<ListCategoriesResponse>>;
}

interface CreateCategoryFormValues {
  name: string;
  reference: string;
  description?: string;
  [key: string]: unknown;
}

export default function CreateCategoryDrawer(
  props: CreateCategoryDrawerPropsTypes,
): React.ReactElement {
  const { refetchCategories } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const urlParams: RouteParams = useParams();

  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const { createUpdateCategory } = useCategoryApi();
  const { notificationSuccessfullySaved, notificationError } = useNotification();

  const onFinish = async (values: CreateCategoryFormValues) => {
    let errors: ErrorType[] | undefined = [];

    const variables = {
      input: {
        name: values?.name,
        reference: values?.reference,
        description: values?.description,
        companyId: urlParams.companyId,
      },
    };

    const response = await createUpdateCategory({ variables });

    errors = response?.data?.createCategory?.errors;

    if (errors && errors.length > 0) {
      const fieldsData = getFormError(errors, values);
      notificationError(errors);
      form.setFields(fieldsData);
    } else {
      refetchCategories!();
      notificationSuccessfullySaved(t("Category"));
      form.resetFields();
      setIsDrawerVisible(false);
    }
  };

  const showModal = () => {
    setIsDrawerVisible(true);
  };

  const handleCancel = () => {
    setIsDrawerVisible(false);
  };
  const handleOnClick = () => {
    form.submit();
  };

  return (
    <>
      <Row justify="end">
        <TooltipButton
          title={t("Add category")}
          placement="top"
          handleOnClick={showModal}
          icon={<FaPlus />}
        />
      </Row>
      <Drawer
        width={576}
        title={t("Add category")}
        open={isDrawerVisible}
        onClose={handleCancel}
        extra={
          <Space>
            <Button onClick={handleCancel}>{t("Cancel")}</Button>
            <Button onClick={handleOnClick} type="primary">
              {t("Add")}
            </Button>
          </Space>
        }
      >
        <Form
          name="createUpdateCategory"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                name="reference"
                label={t("Reference")}
                rules={[{ required: true, message: t("This field is required") }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="name"
                label={t("Name")}
                rules={[{ required: true, message: t("This field is required") }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="description" label={t("Description")}>
                <TextArea style={{ height: 150 }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
}
